query company($id: String) {
  company(id: $id) {
    id
    site {
      id
      url
    }
  }
}
